const levelsDict = Object.freeze({
  none: 'level.none',
  center: 'level.center',
  region: 'level.region',
  district: 'level.district',
  municipality: 'level.municipality',
  school: 'level.school',
  company: 'level.company',
  healthRegion: 'level.healthRegion',
  companySpecialist: 'level.companySpecialist',
  centerCompany: 'level.centerCompany',
  student: 'level.student',
  location: 'level.location',
});
export default levelsDict;

export const levels = [
  {
    id: 48,
    name: 'level.center',
  },
  {
    id: 167,
    name: 'level.company',
  },
  {
    id: 405,
    name: 'level.companySpecialist',
  },
  {
    id: 59,
    name: 'level.district',
  },
  {
    id: 1513,
    name: 'level.healthRegion',
  },
  {
    id: 46,
    name: 'level.municipality',
  },
  {
    id: 456,
    name: 'level.providerSpecialist',
  },
  {
    id: 47,
    name: 'level.region',
  },
  {
    id: 49,
    name: 'level.school',
  },
  {
    id: 455,
    name: 'level.serviceSpecialist',
  },
  {
    id: 1743,
    name: 'level.centerCompany',
  },
  {
    id: 1758,
    name: 'level.student',
  },
  {
    id: 19340,
    name: 'level.location',
  },
];

export const getAccessLevelIds = () => levels.map((x) => x.id);
